/* eslint-disable no-unused-vars */
const THREE = window.THREE;
import $ from 'jquery';
import store from '@/store';
import { initProj4, loadScript } from './forgeService';
import {
  getForgeToken,
  rotateViewerCamera,
  getViewerCurrentPdfPagesCount,
  setModelVisibility,
  addViewable,
} from '../../utils/forgeUtils';
import { saveState } from '../../utils/mongoUtils';
import { saveModelOffsets } from '@/services/forge.service';
import appConfig from '../../../appConfig';
import Vue from 'vue';
import router from '@/router';
import { getEmptyFileUrl } from '@/utils/attachmentsAPI';
import { $getAuthHeaders } from '@/utils/index.js';
import CompareToolExtension from '@/extensions/CompareToolExtension';
import PivotSetterTool from '@/extensions/PivotSetterTool';
import { fetchDocumentAsObjectUrl } from '@/utils/documentProxyUtils';
import { refreshDocumentVersionNotice, cancelDocumentVersionNotice } from '@/features/Documents/utils/viewerVersionNotice';
import {
  logViewerInit,
  logViewerReady,
  logViewerDispose,
  logExtensionLoad,
  startTimer,
  log as debugLog,
  warn as debugWarn,
  error as debugError
} from '@/utils/debugLogger';
import { LINK_TYPE_COLORS } from '@/constants/linkTypeColors';
import { POSITION_PICK_SOURCE } from '@/constants/positionPickSource';
import { resolveLinkCmlId, applyCmlConditionColorsToDocLinks } from '@/utils/docLinkConditionColors';
import { resolvePersistUnitScale } from '@/utils/coordinateAuthority';
import { getModelNotReady, createModelNotReadyError } from './modelReadiness';
import { runPlanLoadCallback } from './planLoadCallback';
const Autodesk = window.Autodesk;

export function launchViewer(
  urn,
  dispose3DOnly,
  area,
  streamingApi = 'streamingV2_EU',
  { pointCloudOnly = false } = {},
) {
  return new Promise((resolve, reject) => {
    const viewerTimer = startTimer('Forge 3D Viewer');

    logViewerInit('Forge 3D Viewer', {
      urn: urn ? urn.substring(0, 20) + '...' : 'none',
      dispose3DOnly,
      area,
      api: streamingApi
    });

      window.USE_OPFS = false;

      if (pointCloudOnly) {
        store.commit('SET_UNIT_SCALE', 1);
        store.commit('SET_GLOBAL_OFFSET', new THREE.Vector3(0, 0, 0));
      }

      store.state.currentUrn = urn;
      initProj4();

      $('.clickoff').css('width', '100%');
      $('.clickoff').css('height', '100%');
      if (store.state.viewer) {
        if (dispose3DOnly) dispose3DViewer();
        else disposeForgeViewers();
      }
      store.commit('SET_PAGE_VIEW_3D', null);
      store.state.mainUrn = urn;
      var options = {
        getAccessToken: getForgeToken,
        env: 'AutodeskProduction2',
        api: streamingApi,
        useOpfs: false
      };

      var config = {
        skipPropertyDb: true,
        startOnInitialize: true,
        extensions: ['Autodesk.BimWalk', 'Autodesk.Snapping', 'Autodesk.DocumentBrowser', 'Autodesk.ADN.WalkingPathToolExtension', CompareToolExtension.extensionId, 'PointCloudEraserExtension'],
        disabledExtensions: {
          measure: true,
          section: true,
        },
      };

      // config["loaderExtensions"] = { svf: "Autodesk.MemoryLimited" };
      // config["memory"] = {
      //     limit: 4024,
      //     debug: {
      //         force: true
      //     }
      // }

      store.state.viewerState.isLoading = true;

      Autodesk.Viewing.Initializer(options, () => {
        let htmlDiv = document.createElement('div');

        htmlDiv.id = 'forgeViewer';
        htmlDiv.style.width = '100%';
        htmlDiv.style.height = '100%';

        let parentNode = document.getElementById('viewer3d');

        if (!parentNode || parentNode?.style.display === 'none') {
          parentNode = document.getElementById('viewer3d-temp');
        }

        if (!parentNode) {
          return reject(new Error('3D viewer host not found.'));
        }

        if (parentNode?.firstChild) {
          parentNode.insertBefore(htmlDiv, parentNode.firstChild);
        } else {
          parentNode.appendChild(htmlDiv);
        }

        store.state.viewer = new Autodesk.Viewing.GuiViewer3D(htmlDiv, config);

        store.state.viewer.loadExtension('MainExtension');
        store.state.viewer.loadExtension('TouchSelectionExtension');
        store.state.viewer.loadExtension('MeasurementExtension');
        store.state.viewer.loadExtension('Cropping3DExtension');
        store.state.viewer.loadExtension('ScaffoldBoxExtension');
        store.state.viewer.start();

        const progressCallback = (e) => {
          store.state.viewerState.percent = e.percent;
          store.state.viewerState.isLoading = e.percent != 100;
          if (e.percent == 100) {
            store.state.viewerState.percent = 0;
            store.state.viewer.removeEventListener(Autodesk.Viewing.PROGRESS_UPDATE_EVENT, progressCallback);
          }
        }

        store.state.viewer.addEventListener(Autodesk.Viewing.PROGRESS_UPDATE_EVENT, progressCallback);

        //Change Forge logo to Reality logo
        $('.forge-spinner img').attr('src', require(`@/images/RealityLoaderNew.png`));
        Autodesk.Viewing.Document.load(
          'urn:' + urn,
          (doc) => {
            try {
              Promise.resolve(onDocumentLoadSuccess(doc, area, { pointCloudOnly }))
                .then(() => {
                  store.commit('SET_PAGE_VIEW_3D', htmlDiv);
                  resolve();
                })
                .catch(reject);
            } catch (err) {
              reject(err);
            }
          },
          (viewerErrorCode) => {
            onDocumentLoadFailure(viewerErrorCode);
            reject(new Error(`Forge document load failed with error code ${viewerErrorCode}.`));
          },
        );

        const callback = () => {
          if (store.state.viewer) {
            store.state.viewer.resize();
            store.state.viewer.getExtension("MeasurementExtension")?.resizeCanvas();

            if (store.getters['getShowComparasionTool']) {
              store.state.forgeService.linkViewers(true);
            }
          }
        };
        const observer = new ResizeObserver(callback);
        observer.observe(htmlDiv);

      });
  });
}
export function launchPlanViewer(urn, callback, streamingApi = 'streamingV2_EU') {
  return new Promise((resolve, reject) => {
    store.commit('hideThumbnailPopup', '2d');
    dispose2DViewer();
    if (!urn) return reject('No plan urn provided.');

    var options = {
      getAccessToken: getForgeToken,
      env: 'AutodeskProduction2',
      api: streamingApi,
    };
    store.state.planUrn = urn;
    Autodesk.Viewing.Initializer(options, () => {
      let htmlDiv = document.createElement('div');

      htmlDiv.id = 'forgePlanViewer';
      htmlDiv.style.width = '100%';
      htmlDiv.style.height = '100%';

      let parentNode = document.getElementById('planViewer');

      if (parentNode?.style.display === 'none') {
        parentNode = document.getElementById('planViewer-temp');
      }

      if (!parentNode) return;

      if (parentNode?.firstChild) {
        parentNode.insertBefore(htmlDiv, parentNode.firstChild);
      } else {
        parentNode.appendChild(htmlDiv);
      }

      store.state.planViewer = new Autodesk.Viewing.GuiViewer3D(htmlDiv, {
        disabledExtensions: { measure: true },
      });

      store.state.planViewer.start();

      $('.forge-spinner img').attr('src', require(`@/images/RealityLoaderNew.png`));
      Autodesk.Viewing.Document.load(
        'urn:' + urn,
        (doc) => {
          var defGeo = doc.getRoot().getDefaultGeometry();
          store.state.planViewer.loadDocumentNode(doc, defGeo).then(() => {
            store.state.planViewer.setBackgroundColor(255, 255, 255, 255, 255, 255);

            // Loads labels3dExt, then runs the pending callback (it may highlight tags with it).
            runPlanLoadCallback(store, store.state.planViewer, (err) =>
              debugError('[Forge] Plan labels extension failed to load:', err),
            ).catch((err) => debugError('[Forge] 2D load callback failed:', err));
            store.state.planViewer.loadExtension('Plan2DExtension').then((ex) => {
              ex.drawDirection2D();
            });

            store.state.planViewer.loadExtension('MeasurementExtension');

            store.state.planViewer.navigation.setReverseZoomDirection(true);
            // store.state.planViewer.navigation.setZoomOutLimitFactor(2);
            let c = store.state.planViewer.navigation.getConstrains2D();
            store.state.planViewer.navigation.setConstraints2D(c.maxViewRegion, c.maxPixelPerUnit * 10)

            resolve();
          });
        },
        (errorMsg) => debugError,
      );

      const callback = () => {
        if (store.state.planViewer) {
          store.state.planViewer.resize();
          store.state.planViewer.getExtension("MeasurementExtension")?.resizeCanvas();
        }
      };
      const observer = new ResizeObserver(callback);
      observer.observe(htmlDiv);

      store.commit('SET_PAGE_VIEW_2D', htmlDiv);
    });
  });
}

export function addEmptyModelToViewer() {
  if (!store.state.viewer) return new Promise((resolve, reject) => reject('No viewer found.'));
  let emptyUrn = getEmptyModelUrn();
  return addViewable(store.state.viewer, emptyUrn, null, store.state.globalOffset);
}

export function getEmptyModelUrn() {
  return 'dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6ZW52aXppb24tZW1wdHktbW9kZWwvZW1wdHkucnZ0';
}

/** Lower-case extension of an attachment name, which may be a plain file name or a URL. */
export function attachmentExtension(name) {
  let filename = name || '';
  try {
    // If name is a URL, extract just the pathname filename (strips query/fragment)
    let parsed = new URL(filename);
    filename = parsed.pathname.split('/').pop() || filename;
  } catch {
    // Not a URL — it's a plain filename, use as-is
  }
  let dotIndex = filename.lastIndexOf('.');
  return dotIndex !== -1 ? filename.slice(dotIndex + 1).trim().toLowerCase() : '';
}

/**
 * Sets whether the markups viewer shows an image (drawn on an empty PDF page) or a PDF, from the
 * file name of what is about to be shown. Versions of one document can differ (v1.pdf, v2.png), so
 * this is decided per version. Returns false when the file is neither; another viewer shows it.
 */
export function setMarkupFileKind(name) {
  const ext = attachmentExtension(name);
  if (isImageViewer(ext)) store.state.isMarkupImage = true;
  else if (isPdfViewer(ext)) store.state.isMarkupImage = false;
  else return false;
  return true;
}

/**
 * True when `attachment` is the markups attachment already on screen, for the same document version.
 * A version nobody has marked up has no attachment id yet, so two such versions must not count as
 * the same; nor does the same document at another version (links are per version).
 */
function isSameViewOpen(current, attachment) {
  if (!current?.id || current.id !== attachment?.id) return false;
  return (current.viewRevisionId || null) === (attachment.viewRevisionId || null);
}

export function openAttachment(attachment) {
  if (!attachment?.url) {
    Vue.prototype.$dialog.notify.warning('NO valid attachment to open.');

    return;
  }

  let ext = attachmentExtension(attachment.name);

  if (setMarkupFileKind(attachment.name)) {

    // Check if same document is already open - just highlight without reopening
    const currentAttachment = store.getters['getActiveAttachment'];
    const highlightedId = store.getters['getTagIdToHighlight'];
    if (isSameViewOpen(currentAttachment, attachment) && store.state.pdfViewerLoaded && highlightedId) {
      // Document already open, just highlight the link
      const activeAttachment = store.getters['getActiveAttachment'];
      const page = activeAttachment?.pagesMarkups?.find((o) => o.pageId == store.getters['getActiveAttachmentPage']);
      const link = page?.links?.find((l) => l.tagId == highlightedId);
      if (link) {
        highlightLinkElement(link, store.state.pdfviewer);
      }
      store.commit('setTagIdToHighlight', null);
      return;
    }

    if (!getViewPageDoc()) {
      store.state.mainApp.openViewPageWithType('doc');
    } else {
      store.state.mainApp.showViewPageWithType('doc');
    }

    setTimeout(() => {
      launchPDFViewer(attachment);
    }, 100);
  } else if (isVideoViewer(ext)) {
    if (!getViewPageVideo()) {
      store.state.mainApp.openViewPageWithType('vid');
    } else {
      store.state.mainApp.showViewPageWithType('vid');
    }

    store.commit('setActiveVideoSrc', attachment.url);
  } else if (isOfficeViewer(ext)) {
    if (!getViewPageOfficeDoc()) {
      store.state.mainApp.openViewPageWithType('office-doc');
    } else {
      store.state.mainApp.showViewPageWithType('office-doc');
    }
    store.commit('SET_OFFICE_DOCUMENT_URL', encodeURIComponent(attachment.url));
  } else {
    window.open(attachment.url, '_blank').focus();
  }

  store.commit('setActiveAttachment', attachment);
}

export function isOfficeViewer(ext) {
  return /( xls|xlsx|xlsm|docx|doc|pptx|ppt)$/i.test(ext);
}

export function isVideoViewer(ext) {
  return /(mp4|webm|ogg)$/i.test(ext);
}

/** Images the APS viewer can show (drawn onto an empty page): formats browsers decode. Not TIFF. */
export function isImageViewer(ext) {
  return /^(png|jpe?g|gif|bmp|webp)$/i.test(ext);
}

export function isPdfViewer(ext) {
  return /(pdf)$/i.test(ext);
}

export function stopForge() {
  disposeForgeViewers();
  store.state.adminAppContainer = null;
  store.state.mainApp = null;
  store.state.markupsApp = null;
}
export function dispose3DViewer() {
  store.commit('hideThumbnailPopup', '3d');
  store.commit('setIsTreeLoaded', false);
  store.commit('setIsGeometryLoaded', false);
  // CML markers are child meshes of the viewer scene — they die with the viewer here,
  // but nothing clears the ownership token, so a re-mounted drawer would read a stale ON.
  store.commit('SET_CML_MARKER_OWNER', null);

  if (store.state.viewer) {
    store.state.viewer.finish();
    window.Autodesk.Viewing.shutdown(store.state.viewer);
    store.state.viewer = null;
  }
}
export function dispose2DViewer() {
  debugLog(`%c dispose2DViewer`, `color: red; font-size: 16px;`);
  store.commit('hideThumbnailPopup', '2d');

  if (store.state.planViewer) {
    store.state.planViewer.finish();
    store.state.planViewer = null;
  }
}
export function disposeDocViewer() {
  if (store.state.pdfviewer) {
    store.state.pdfviewer.finish();
    store.state.pdfviewer = null;
  }
  store.commit('setActiveAttachment', null);
  store.commit('setActiveAttachmentPage', 0);
  store.commit('setActiveAttachmentPagesCount', 0);
  // Also drops a notice request still in flight, so it cannot reappear after the viewer closed.
  cancelDocumentVersionNotice(store);
}
export function disposeForgeViewers() {
  dispose3DViewer();
  dispose2DViewer();
  disposeDocViewer();
  if (store.state.forgeService && store.state.forgeService.panoramaViewer)
    store.state.forgeService.panoramaViewer.destroy();

  if (store.state.mainApp && getMarkupsComponent() && getMarkupsComponent().markupViewer) {
    getMarkupsComponent().markupViewer.finish();
    getMarkupsComponent().markupViewer = null;
  }
  Autodesk.Viewing.shutdown();
}

var startedPanning = false;
export function onDocumentLoadSuccess(doc, area, { pointCloudOnly = false } = {}) {
  var viewables = doc.getRoot().getDefaultGeometry();
  // A model that failed translation or is still translating has no viewable URN; loading it
  // would never settle. Reject instead, and clear the overlay the progress callback would clear.
  const notReady = getModelNotReady(doc, viewables);
  if (notReady) {
    store.state.viewerState.isLoading = false;
    throw createModelNotReadyError(notReady.status);
  }
  const options = {
    // applyScaling: { to: 'm' },
    // filter: {
    //   "spatial_query": {
    //     "$encloses": [{ 'aabox': [-300, -800, -40, 0, -350, +40] }]
    //   },
    // }
  };

  options.filter = {
    "property_query": {
      $not: {
        "$eq": { "?Layer": "'Unknown'" }
      }
    }
  }

  if (area?.length) {
    // area can be either a single aabox array (length===6) or an array of such arrays.
    const areaBoxes = Array.isArray(area[0]) ? area : [area];

    let spatialQuery = {};

    if (areaBoxes.length === 1) {
      // Single bounding box – keep the previous behaviour.
      spatialQuery = {
        $encloses: [{ aabox: areaBoxes[0] }],
      };
    } else {
      // Multiple bounding boxes – build an OR filter so that any box qualifies.
      spatialQuery = {
        $or: areaBoxes.map((box) => ({
          $encloses: [{ aabox: box }],
        })),
      };
    }

    options.filter = {
      ...options.filter,
      spatial_query: spatialQuery,
    };

    options.useConsolidation = false;

    store.state.viewer.addEventListener(Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT, () => {
      try {
        // Build a combined bounding box from all provided area boxes
        let min = new THREE.Vector3();
        let max = new THREE.Vector3();

        areaBoxes.forEach((box, idx) => {
          const bMin = new THREE.Vector3(box[0], box[1], box[2]);
          const bMax = new THREE.Vector3(box[3], box[4], box[5]);

          if (idx === 0) {
            min.copy(bMin);
            max.copy(bMax);
          } else {
            min.min(bMin);
            max.max(bMax);
          }
        });

        const combinedBox = new THREE.Box3(min, max);
        store.state.viewer.navigation.fitBounds(true, combinedBox);
      } catch (error) {
        debugWarn('Failed to fit bounds for provided area:', error);
      }
    }, { once: true });
  }

  if (store.getters.GET_DB_IDS_TO_LOAD?.length) {
    options.ids = [...store.getters.GET_DB_IDS_TO_LOAD];
    // options.useConsolidation = false;
  }

  const modelLoad = store.state.viewer.loadDocumentNode(doc, viewables, options).then((i) => {
    store.dispatch('SET_VIEWER_DISPLAY_DEFAULT_PREFERENCES');

    if (pointCloudOnly) {
      store.commit('SET_UNIT_SCALE', 1);
      store.commit('SET_GLOBAL_OFFSET', new THREE.Vector3(0, 0, 0));
    } else {
      const currentOffset = store.state.viewer.model.getGlobalOffset();
      const currentUnitScale = store.state.viewer.model.getUnitScale();

      // Check if we need to save offsets to database (not already loaded or is default)
      const needsToSave = !store.state.globalOffset ||
                         (store.state.globalOffset.x === 0 &&
                          store.state.globalOffset.y === 0 &&
                          store.state.globalOffset.z === 0);

      // globalOffset: the LIVE model is the authority — it defines viewer space.
      // unitScale: the user-confirmed displayUnit is the authority; the model's
      // self-declared getUnitScale() only fills the gap (it returns 1 for
      // mis-declared SVF re-uploads — trusting it here is what corrupted
      // Objects3D.Center into raw model mm).
      const resolution = resolvePersistUnitScale(store.state.viewer.model);
      const effectiveUnitScale = resolution.scale || currentUnitScale;

      store.commit('SET_GLOBAL_OFFSET', currentOffset);
      store.commit('SET_UNIT_SCALE', effectiveUnitScale);

      if (resolution.conflict) {
        debugWarn('[Forge] Unit mismatch on model load: facility displayUnit ' +
          `'${resolution.displayUnit}' (scale ${resolution.scale}) vs model-declared ` +
          `${currentUnitScale}. Keeping the facility unit.`);
      }

      if (needsToSave) {
        // Save to database
        const assetId = store.state.assetId;

        if (assetId && currentOffset) {
          saveModelOffsets(assetId, currentOffset, effectiveUnitScale)
            .then((response) => {
              debugLog('[Forge] Model metadata saved successfully:', {
                assetId: assetId,
                modelName: response.data.modelName,
                globalOffset: currentOffset,
                unitScale: effectiveUnitScale
              });
            })
            .catch((error) => {
              debugError('[Forge] Failed to save model metadata:', error);
              // Don't throw - viewer should still work even if save fails
            });
        }
      } else {
        debugLog('[Forge] Model metadata: live offset + authority unit scale', {
          globalOffset: currentOffset,
          unitScale: effectiveUnitScale,
          unitScaleSource: resolution.source
        });
      }
    }

    var walkEx = store.state.viewer.getExtension('Autodesk.BimWalk');
    if (walkEx) walkEx.tool.navigator.enableGravity(false);
    store.state.viewer.loadExtension('Autodesk.Section').then((ex) => {
      setTimeout(() => {
        $('#toolbar-sectionTool').css('display', 'none');
      }, 100);
    });
    store.state.viewer.loadExtension('labels3dExt');
    store.state.viewer.loadExtension('CustomContextMenuExtension');
    store.state.viewer.loadExtension('Mapping2d_3dExtension');

    //update 3d icons in 360 viewer in case if opened
    store.state.forgeService.updateTagsAnnotationsInPanoViewer();
    store.state.forgeService.update360ImagesHotspots();
    store.state.forgeService.update3dIconsInAllViews();

    let current = store.getters['getDisplayUnit'];
    let modelUnit = store.state.viewer.model.getUnitString();

    if (store.state.userSettings.displaySettings) {
      setModelVisibility(store.state.viewer, store.state.viewer.model, store.state.userSettings.displaySettings.showMasterModel);
    }

    /*
        ** Admin side
        > We Stored any model displayUnit in the admin section when the user opens it in the viewer (launchViewer3D => admin-container) to :
            1- Show the 3D model.
            2- Mapping 2D plan model with 3D model.

        ** User side
        > We got the displayUnit for the selected model from DB in the fetchAllForgeModel request.

        > There are 2 cases where displayUnit needs to update :
            1- The user does not open  any 3D viewer in the admin section, so displayUnit will be null.
            2- The displayUnit is not the Model displayUnit.
        */
    if (!current) {
      // Fill-when-missing only. The model's unit string is a suggestion;
      // once a facility displayUnit exists it is user-confirmed authority and
      // must never be silently overwritten from model metadata (a mis-declared
      // model would permanently flip the facility back to the wrong unit).
      store.dispatch({
        type: 'updateDisplayUnit',
        displayUnit: modelUnit,
      });
    } else if (modelUnit && modelUnit != current) {
      debugWarn(`[Forge] Model unit string '${modelUnit}' differs from facility display unit ` +
        `'${current}' — keeping the facility unit. Update it manually if the model really changed units.`);
    }
  });

  let pointerEnd = (evt) => {
    if (!store.state.forgeService) return;

    if (store.state.isPickingCmlPoint) {
      var cmlHitTest = store.state.viewer.clientToWorld(evt.offsetX, evt.offsetY, false);
      if (cmlHitTest && cmlHitTest.point) {
        var worldPoint = store.state.forgeService.view3dToWorld(cmlHitTest.point);
        var callback = store.state.pickingCmlCallback;
        // Pass dbId through so callers (e.g. CmlAddEditPanel) can store
        // the picked element's identifier alongside the 3D coordinates.
        if (callback) callback({
          x: worldPoint.x,
          y: worldPoint.y,
          z: worldPoint.z,
          dbId: cmlHitTest.dbId != null ? cmlHitTest.dbId : null,
          fragId: cmlHitTest.fragId != null ? cmlHitTest.fragId : null,
        });
        store.commit('setIsPickingCmlPoint', false);
        store.commit('setPickingCmlCallback', null);
        store.state.forgeService.toggleCrossHairCursorToViewer(false, store.state.viewer);
      }
      return;
    }

    // Tag "Set Point" — 3D leg. The 360 leg lives in the panorama click handler
    // (forgeService). Every tag kind can be placed from either view, so this
    // branch consumes the click for all tag kinds, not just the scaffold family.
    if (store.state.isSettingTagPosition) {
      const posTag = store.state.positionAssignmentTag;
      if (posTag) {
        let posHitTest = store.state.viewer.clientToWorld(evt.offsetX, evt.offsetY, false);
        let posOnModel = posHitTest && posHitTest.point ? posHitTest.point : null;
        let posOnPointCloud = store.state.forgeService
          .getMainExtension()
          .pickNearestPointCloudPoint(evt);
        if (!posOnModel && !posOnPointCloud) {
          Vue.prototype.$dialog.notify.warning('Please pick point on any element.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        let posCameraPt = store.state.viewer.navigation.getPosition();
        let posPicked;
        if (posOnModel && posOnPointCloud)
          posPicked =
            posCameraPt.distanceTo(posOnModel) < posCameraPt.distanceTo(posOnPointCloud)
              ? posOnModel
              : posOnPointCloud;
        else posPicked = posOnModel || posOnPointCloud;
        let posWorldPoint = store.state.forgeService.view3dToWorld(posPicked);
        // Element identity travels with the point, mirroring the CML branch above.
        // A point-cloud hit has no element, so both ids stay null whenever the
        // chosen point did not come from clientToWorld.
        const posPickedFromModel = posPicked === posOnModel;
        const posDbId = posPickedFromModel && posHitTest?.dbId != null ? posHitTest.dbId : null;
        const posFragId = posPickedFromModel && posHitTest?.fragId != null ? posHitTest.fragId : null;
        debugLog('[SetPoint] 3D pick resolved', {
          tagId: posTag?.id,
          tagType: posTag?.type,
          tagClass: posTag?.constructor?.name,
          hitSource: posPickedFromModel ? 'model' : 'pointCloud',
          dbId: posDbId,
          fragId: posFragId,
        });
        const posCallback = store.state.positionAssignmentCallback;
        if (posCallback)
          posCallback({
            x: posWorldPoint.x,
            y: posWorldPoint.y,
            z: posWorldPoint.z,
            dbId: posDbId,
            fragId: posFragId,
            // Both the model hit and the point-cloud fallback are 3D-leg picks.
            source: POSITION_PICK_SOURCE.MODEL_3D,
          });
        store.commit('setIsSettingTagPosition', false);
        store.commit('setPositionAssignmentTag', null);
        store.commit('setPositionAssignmentCallback', null);
        store.state.forgeService.toggleCrossHairCursorToViewer(false, store.state.viewer);
        if (store.state.planViewer)
          store.state.forgeService.toggleCrossHairCursorToViewer(false, store.state.planViewer);
        $('.pnlm-ui').css('cursor', '');
        return;
      }
    }

    let isPickingTag = store.state.isPickingTag;
    let isPickingSubTag = store.state.isPickingSubTag;
    let isPickingCropOrigin = store.state.isPickingCropOrigin;
    let isPickingPin = store.state.isPickingPin;

    if (isPickingTag || isPickingCropOrigin || isPickingSubTag || isPickingPin) {
      var hitTest = store.state.viewer.clientToWorld(evt.offsetX, evt.offsetY, false);
      let point = null;
      let pointOnModel = null;
      if (hitTest && hitTest.point) pointOnModel = hitTest.point;
      let pointOnPointCloud = store.state.forgeService
        .getMainExtension()
        .pickNearestPointCloudPoint(evt);
      let cameraPt = store.state.viewer.navigation.getPosition();
      if (!pointOnModel && !pointOnPointCloud) {
        Vue.prototype.$dialog.notify.warning('Please pick point on any element.', {
          position: 'top-right',
          timeout: 3000,
        });
        if (isPickingPin) store.commit('setIsPickingPin', false);
        return;
      } else if (pointOnModel && pointOnPointCloud)
        point =
          cameraPt.distanceTo(pointOnModel) < cameraPt.distanceTo(pointOnPointCloud)
            ? pointOnModel
            : pointOnPointCloud;
      else if (pointOnModel) point = pointOnModel;
      else point = pointOnPointCloud;

      let viewerPt = point.clone();
      //to give Forge time to update selection
      setTimeout(() => {
        let selection = store.state.viewer.model.selector.getSelection();
        if (isPickingTag && selection.length > 0) {
          store.state.forgeService.createTagFromSelection();
        } else if (isPickingTag) {
          store.commit('setIsPickingTag', false);
          let globalPt = store.state.forgeService.view3dToWorld(point);
          store.state.forgeService.addNewTag('3d', globalPt, null, true);
        } else if (isPickingCropOrigin) {
          debugLog(`%c Viewer point: ${viewerPt.x}, ${viewerPt.y}, ${viewerPt.z}`, `color: red; font-size: 16px;`);
          store.state.forgeService.crop3D(viewerPt);
        } else if (isPickingSubTag) {
          let globalPt = store.state.forgeService.view3dToWorld(point);
          store.state.forgeService.addSubInspection(globalPt);
        } else if (isPickingPin) {
          store.state.pinnedPoint3d = point;
          store.state.forgeService.getMainExtension().updatePinPoint();
          store.commit('setIsPickingPin', false);
        }
      }, 100);
    }

    var extension = store.state.forgeService.getMainExtension();
    if (
      extension == null ||
      !store.state.areViewsLocked ||
      !store.state.selectedImage ||
      !store.state.forgeService.panoramaViewer ||
      !startedPanning
    )
      return;
    let bimEx = store.state.viewer.getExtension('Autodesk.BimWalk');
    if (bimEx) bimEx.deactivate();
    startedPanning = false;
  };

  let pointerStart = (evt) => {
    store.state.viewerMouseDownEvent = evt;

    if (evt.which == 2 && store.state.areViewsLocked) evt.preventDefault();

    TurnViewerLockOff();

    if (evt.which == 3)
      store.state.mouseDownHitTest = store.state.viewer.clientToWorld(
        evt.offsetX,
        evt.offsetY,
        false,
      );

    var extension = store.state.forgeService.getMainExtension();
    if (
      extension == null ||
      !store.state.areViewsLocked ||
      !store.state.selectedImage ||
      !store.state.forgeService.panoramaViewer
    )
      return;
    let bimEx = store.state.viewer.getExtension('Autodesk.BimWalk');
    if (bimEx) {
      bimEx.activate();
      setTimeout(() => {
        $('.c-bimwalk-tooltip__actions #dontRemind').click();
      }, 50);
    }
    startedPanning = true;
  };

  // Middle double-click pivot tool
  let pivotTool = new PivotSetterTool(store.state.viewer);
  store.state.viewer.toolController.registerTool(pivotTool);
  store.state.viewer.toolController.activateTool('pivot-setter-tool');

  store.state.viewer.canvas.addEventListener('touchend', pointerEnd);
  store.state.viewer.canvas.addEventListener('touchstart', pointerStart);
  store.state.viewer.canvas.addEventListener('mouseup', pointerEnd);
  store.state.viewer.canvas.addEventListener('mousedown', pointerStart);

  let isFirefox = /Firefox/i.test(navigator.userAgent);
  var mousewheelevt = isFirefox ? 'DOMMouseScroll' : 'mousewheel';
  store.state.viewer.canvas.addEventListener(mousewheelevt, (evt) => {
    // if(store.state.mainApp.showComparasionTool)
    //     return;
    var extension = store.state.forgeService.getMainExtension();
    if (
      extension == null ||
      !store.state.areViewsLocked ||
      !store.state.selectedImage ||
      !store.state.forgeService.panoramaViewer
    )
      return;
    if (!store.state.viewer.getExtension('Cropping3DExtension')?.croppingOn)
      store.state.viewer.navigation.setIsLocked(true);

    store.state.viewer.getExtension('Autodesk.BimWalk').deactivate();
    let delta = isFirefox ? evt.detail : evt.wheelDelta;
    var isZooming = delta > 0;
    // var forgeFocalLength = store.state.viewer.navigation.getFocalLength();
    // if (isZooming) {
    //     forgeFocalLength -= 5;
    //     if (forgeFocalLength < 10)
    //         forgeFocalLength = 10;
    // } else {
    //     forgeFocalLength += 5;
    //     if (forgeFocalLength > 25)
    //         forgeFocalLength = 25;
    // }
    // store.state.viewer.navigation.setFocalLength(forgeFocalLength)

    // var ratio = (25.0 - forgeFocalLength) / 15.0;
    // var newFOV = 50 + 70 * ratio;
    // store.state.forgeService.panoramaViewer.lookAt(store.state.forgeService.panoramaViewer.getPitch(),store.state.forgeService.panoramaViewer.getYaw(),newFOV,0);

    ///===== Old way to Zoom =====///
    // var fov = store.state.viewer.getFOV();

    // if (isZooming) {
    //     fov -= 5;
    //     if (fov < store.state.viewer.navigation.getFovMin())
    //         fov = store.state.viewer.navigation.getFovMin();
    // } else {
    //     fov += 5;
    //     if (fov > store.state.viewer.navigation.getFovMax())
    //         fov = store.state.viewer.navigation.getFovMax();
    // }

    // if(store.state.areViewsLocked) {
    //     let newFOV = fov;

    //     if (store.state.mainApp.localShowComparasionTool) newFOV = fov / 0.6;

    //     let canApply = this.fovOnPanoBounds(newFOV);

    //     if (canApply) {
    //         store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(fov));

    //         store.state.forgeService.panoramaViewer.setHfov(newFOV,false)
    //     }
    // } else {
    //     store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(fov));
    // }
    ///===============================================///

    if (store.state.areViewsLocked) {
      // 3d is connected to 360.
      let currentHFov = store.state.forgeService.panoramaViewer.getHfov();

      let newHFov = currentHFov;

      if (isZooming) newHFov -= 5;
      else newHFov += 5;

      let canApply = store.state.forgeService.isHFovInBounds(newHFov);

      if (canApply) {
        store.state.forgeService.panoramaViewer.setHfov(newHFov, false);
        store.state.forgeService.mapPanoramaHFovTo3dVHov();
      }
    } else {
      // 3d only or 360 is not connected.
      var vFov = store.state.viewer.navigation.getVerticalFov();

      if (isZooming) {
        vFov -= 5;
        if (vFov < store.state.viewer.navigation.getFovMin())
          vFov = store.state.viewer.navigation.getFovMin();
      } else {
        vFov += 5;
        if (vFov > store.state.viewer.navigation.getFovMax())
          vFov = store.state.viewer.navigation.getFovMax();
      }

      store.state.viewer.navigation.setVerticalFov(vFov);
    }
  });

  store.state.viewer.addEventListener(Autodesk.Viewing.SETTINGS_PANEL_CREATED_EVENT, () => {
    setViewerGhosting(false);
  })

  return modelLoad;
}

export function setViewerGhosting(value) {
  let settingsPanel = store.state.viewer?.getSettingsPanel();
  if (settingsPanel) {
    let preferences = settingsPanel.preferences;
    preferences.set('ghosting', value);
  }
}

export function TurnViewerLockOff() {
  if (!store.state.viewer) return;
  if (
    !store.state.viewer.getExtension('Cropping3DExtension')?.croppingOn &&
    !store.state.viewer.getExtension('ScaffoldBoxExtension')?.draggingPoint
  )
    // && !store.state.mainApp.showComparasionTool)
    store.state.viewer.navigation.setIsLocked(false);
}
export function onDocumentLoadFailure(viewerErrorCode) {
  debugError('onDocumentLoadFailure() - errorCode:' + viewerErrorCode);
}

//save/load whole Forge page state
export function getStateId(callback) {
  let cropping3DExtension = store.state.viewer
    ? store.state.viewer.getExtension('Cropping3DExtension')
    : null;
  let state = {
    assetId: store.state.assetId,
    isView1Visible: store.state.mainApp.isView1Visible,
    isView2Visible: store.state.mainApp.isView2Visible,
    isView3Visible: store.state.mainApp.isView3Visible,
    isView4Visible: store.state.mainApp.isView4Visible,
    isLeftMenuPinned: store.state.mainApp.isLeftMenuPinned,
    isTabShown: store.state.isTabShown,
    selectedTab: store.state.selectedTab,
    view1Type: store.state.mainApp.view1Type,
    view2Type: store.state.mainApp.view2Type,
    view3Type: store.state.mainApp.view3Type,
    view4Type: store.state.mainApp.view4Type,
    leftSideViewersWidth: document.getElementById('left-side-viewers').style.width,
    rightSideViewersWidth: document.getElementById('right-side-viewers').style.width,
    topleftViewerHeight: document.getElementById('topleft-viewer').style.height,
    bottomleftViewerHeight: document.getElementById('bottomleft-viewer').style.height,
    topRightViewerHeight: document.getElementById('topright-viewer').style.height,
    bottomRightViewerHeight: document.getElementById('bottomright-viewer').style.height,
    showComparasionTool: store.state.mainApp.localShowComparasionTool,
    panoSeparatorLeft: store.state.mainApp.panoSeparatorLeft,
    viewCompareWidth: store.state.mainApp.viewCompareWidth,
    container360Opacity: getViewPage360() ? getViewPage360().containerOpacity : 0,
    showActivityManager: store.getters['getIsRealityActivityManagerShown'],

    isLockedViewer3DAndPano:
      store.state.selectedImage != null && store.state.selectedImage.isLocked,
    images360ShownProjects: store.state.projects
      .filter((o) => o.images.some((i) => i.isVisibleInViewers))
      .map((o) => o.name),
    viewer3DSettings: !store.state.viewer
      ? null
      : {
        urn: store.state.mainUrn,
        shownPointCloudsUrls: store.state.pointClouds.filter((o) => o.isShown).map((o) => o.url),
        shownSmallModelsUrns: store.state.uploadedModels
          .filter((o) => o.isShown)
          .map((o) => o.urn),
        viewerState: store.state.viewer.getState(),
        measuringLine:
          !store.state.forgeService.getMeasureExtensionInViewer3D() ||
            !store.state.forgeService.getMeasureExtensionInViewer3D().dimensionLine
            ? null
            : {
              start: store.state.forgeService.getMeasureExtensionInViewer3D().dimensionLine.v1,
              end: store.state.forgeService.getMeasureExtensionInViewer3D().dimensionLine.v2,
            },
        cropBox:
          cropping3DExtension && cropping3DExtension.croppingOn && cropping3DExtension.cropBox
            ? cropping3DExtension.cropBox
            : null,
        cropLevels: store.state.levels.filter((o) => o.isCropped).map((o) => o.name),
      },
    viewer2DSettings:
      !getViewPage2d() || !store.state.planViewer
        ? null
        : {
          urn: store.state.selectedLevel ? store.state.selectedLevel.planUrn : null,
          measuredArea: store.state.forgeService.getDrawPointsExtension().areaPoints,
          viewerState: store.state.planViewer ? store.state.planViewer.getState() : null,
          measuringLine:
            !store.state.forgeService.getMeasureExtensionInViewer2D() ||
              !store.state.forgeService.getMeasureExtensionInViewer2D().dimensionLine
              ? null
              : {
                start:
                  store.state.forgeService.getMeasureExtensionInViewer2D().dimensionLine.v1,
                end: store.state.forgeService.getMeasureExtensionInViewer2D().dimensionLine.v2,
              },
        },
    panoViewerSettings:
      !getViewPage360() || !store.state.selectedImage
        ? null
        : {
          areViewsLocked: store.state.areViewsLocked,
          fov: store.state.forgeService.panoramaViewer.getHfov(),
          yaw: store.state.forgeService.panoramaViewer.getYaw(),
          pitch: store.state.forgeService.panoramaViewer.getPitch(),
          image: store.state.selectedImage,
          measuringLineStart: store.state.mainApp.panoMeasureStart
            ? store.state.mainApp.panoMeasureStart
            : null,
          measuringLineEnd: store.state.mainApp.panoMeasureEnd
            ? store.state.mainApp.panoMeasureEnd
            : null,
        },
    markupsViewerSettings: !getMarkupsComponent().markupViewer
      ? null
      : {
        annotationGuid: getMarkupsComponent().annotation.id,
        urn: getMarkupsComponent().markup ? getMarkupsComponent().markup.urn : null,
        pageId: getMarkupsComponent().currentPageId,
        viewerState: getMarkupsComponent().markupViewer
          ? getMarkupsComponent().markupViewer.getState()
          : null,
      },
  };
  saveState(state, callback);
}
export function restoreState(id) {
  store.state.mainApp.restoreState(id);
}
export function drawMeasureLine(measureLine, measureExtension) {
  let start = new THREE.Vector3(measureLine.start.x, measureLine.start.y, measureLine.start.z);
  let end = new THREE.Vector3(measureLine.end.x, measureLine.end.y, measureLine.end.z);
  measureExtension.dimensionLine = new THREE.LineCurve(start, end);
  measureExtension.drawDimensionLine();
}
export function restoreStateToViewer3d() {
  var state = store.state.fetchedState;
  store.state.viewer.restoreState(state.viewer3DSettings.viewerState, false, true);
  store.state.projects
    .filter((o) => state.images360ShownProjects.includes(o.name))
    .forEach((o) => o.setAllImagesVisibleInViewers(true));
  if (state.viewer3DSettings.measuringLine) {
    let measure3DEx = store.state.forgeService.getMeasureExtensionInViewer3D();
    drawMeasureLine(state.viewer3DSettings.measuringLine, measure3DEx);
  }
  if (state.viewer3DSettings.cropBox) {
    let cropping3DExtension = store.state.viewer.getExtension('Cropping3DExtension');
    cropping3DExtension.croppingOn = true;
    cropping3DExtension.cropBox = Object.assign(new THREE.Box3(), state.viewer3DSettings.cropBox);
    cropping3DExtension.toggleCropbox(true);
  }
  if (state.viewer3DSettings.cropLevels) {
    let levs = store.state.levels.find((o) => state.viewer3DSettings.cropLevels.includes(o.name));
    store.state.forgeService.cropLevelIn3D(levs);
  }
  state.viewer3DSettings.shownSmallModelsUrns.forEach((urn) => {
    let model = store.state.uploadedModels.find((o) => o.urn == urn);
    if (model) store.state.forgeService.toggleShowingModel(model);
  });
  state.viewer3DSettings.shownPointCloudsUrls.forEach((url) => {
    let pc = store.state.pointClouds.find((o) => o.url == url);
    if (pc) {
      pc.isShown = !pc.isShown;
      var mainExtension = store.state.forgeService.getMainExtension();
      mainExtension.showPointCloud(pc.name, pc.isShown, pc.url);
    }
  });
  store.state.areViewsLocked = !state.panoViewerSettings
    ? false
    : state.panoViewerSettings.areViewsLocked;

  store.state.fetchedState = null;
}

//markups viewer
export async function launchPDFViewer(attachment) {
  store.state.pdfViewerLoaded = false;
  if (!attachment.url) return;
  if (store.state.pdfviewer) store.state.pdfviewer.finish();

  // Banner when this file, or its markups, is not the current document version
  refreshDocumentVersionNotice(store, attachment);

  // Resolve direct Azure Blob URL with fresh SAS token (or the requested version, see viewRevisionId)
  // The document's own file. An image is drawn onto an empty PDF page, which is the model the
  // viewer loads; drawing the empty page itself instead leaves the image blank.
  var fileUrl = await fetchDocumentAsObjectUrl(attachment);
  var resolvedUrl = fileUrl && (store.state.isMarkupImage ? getEmptyFileUrl() : fileUrl);
  if (!resolvedUrl) {
    // Without this the viewer is handed null and stays blank with no explanation.
    Vue.prototype.$dialog?.notify?.error?.(
      attachment.viewRevisionId ? 'This version could not be loaded.' : 'This document could not be loaded.',
      { position: 'top-right', timeout: 5000 },
    );
    return;
  }

  var pageNumber = 1;
  store.commit('setActiveAttachmentPage', pageNumber);
  Autodesk.Viewing.Initializer({}, () => {
    // Auth headers required for non-document Forge API requests (3D models, attachments, etc.)
    Autodesk.Viewing.endpoint.HTTP_REQUEST_HEADERS = $getAuthHeaders();

    store.state.pdfviewer = new Autodesk.Viewing.Private.GuiViewer3D(
      document.getElementById('docViewer'),
      { extensions: ['Autodesk.DocumentBrowser'] },
    );
    store.state.pdfviewer.setTheme('light-theme');
    store.state.pdfviewer.start();
    $('.forge-spinner img').attr('src', require('@/images/RealityLoaderNew.png'));
    store.state.pdfviewer.loadExtension('Autodesk.PDF').then(() => {
      debugLog(`%c pdfUrl: ${resolvedUrl}`, 'color: red; font-weight: bold;');
      store.state.pdfviewer.loadModel(
        resolvedUrl,
        {
          page: pageNumber,
        },
        () => {
          store.state.pdfviewer.setBackgroundColor(255, 255, 255, 255, 255, 255)

          if (store.getters['getIsFlutterRunning']) onMarkupViewerLoaded();
          //draw image on plane if image
          if (store.state.isMarkupImage) drawImageOnPlane(fileUrl, store.state.pdfviewer);
          $('#docViewer #guiviewer3d-toolbar').css('display', 'none');

          var pagesCount = getViewerCurrentPdfPagesCount(store.state.pdfviewer);
          store.commit('setActiveAttachmentPagesCount', pagesCount);

          //Load Markups into doc Viewer
          let markupText = '';
          let markupJson = {};
          var activeAttachment = store.getters['getActiveAttachment'];
          if (activeAttachment.pagesMarkups) {
            let page = activeAttachment.pagesMarkups.find((o) => o.pageId == 1);
            if (page && page.markupText) {
              markupText = page.markupText;
              markupJson = JSON.parse(markupText);
            }
            if (page?.rotation) {
              rotateViewerCamera(store.state.pdfviewer, page?.rotation);
            }
            // remove previous links if any...
            $(store.state.pdfviewer.container).find('.markup-link').remove();

            if (page && page.links) {
              let highlightedId = store.getters['getTagIdToHighlight'];
              let highlightedLink = null;

              page.links.forEach((link) => {
                // Track the link to highlight for flash animation
                if (highlightedId && link.tagId == highlightedId) {
                  highlightedLink = link;
                }

                var iconOptions = {
                  position: link.position,
                  width: link.width,
                  height: link.height,
                  rotation: link.rotation,
                  differences: null,
                  title: link.name,
                  id: link.id ?? link.linkedAttachmentId,
                  className: 'markup-link',
                  forgeViewer: store.state.pdfviewer,
                  metadata: link.tagId,
                  linkType: link.type,
                  cmlId: resolveLinkCmlId(link),
                  onClick: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    var element = e.srcElement;
                    link.element = element;
                    store.commit('setPreviewingLinkElement', element);
                    store.commit('setPdfViewerPreviewingLink', link);
                  },
                  addContent: true,
                  removeTildeSign: true,
                };
                store.state.forgeService.create3DIconToViewer(iconOptions);
              });

              // Patch CML/TML links to their condition color once the facility
              // coloring map resolves (render-then-patch; fails open to link-type color).
              applyCmlConditionColorsToDocLinks(store.state.pdfviewer.container);

              // Apply flash animation to the highlighted link after all links are rendered
              // Use 300ms delay to ensure DOM elements are fully positioned
              if (highlightedLink) {
                setTimeout(() => {
                  highlightLinkElement(highlightedLink, store.state.pdfviewer);
                }, 300);
              }

              store.commit('setTagIdToHighlight', null);
            }
          }
          updateMarkupsOnViewer(store.state.pdfviewer, markupJson, 'Layer_1');
        },
      );
      store.state.pdfviewer.navigation.setReverseZoomDirection(true);
      store.state.pdfViewerLoaded = true;
    });

  var htmlDev=document.getElementById('docViewer');
    const callback = () => {
          if (store.state.pdfviewer) {
            store.state.pdfviewer.resize();
          }
        };
        const observer = new ResizeObserver(callback);
        observer.observe(htmlDev);
  });


}

/**
 * Inject link highlight CSS if not already present.
 * Required because origin-styles.css is only loaded in MarkupsView.
 */
function ensureLinkHighlightStyles() {
  if (document.getElementById('link-highlight-styles')) return;
  const style = document.createElement('style');
  style.id = 'link-highlight-styles';
  style.textContent = `
    .markup-link-popup.highlighted-link,
    .markup-link.highlighted-link,
    .v7-annotation-box.highlighted-link {
      /* Selected/active link — a pulsing condition-colored glow disc (::after),
         matching the 3D sphere-glow and the 360 glow so the cross-viewer highlight
         reads the same in every viewer. Color from --flash-color (the CML condition
         color via cross-viewer sync; link-type otherwise). */
      box-shadow: none;
      z-index: 100 !important;
      filter: none !important;
    }
    .markup-link-popup.highlighted-link::after,
    .markup-link.highlighted-link::after,
    .v7-annotation-box.highlighted-link::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: var(--flash-color, #03624C);
      transform: translate(-50%, -50%);
      animation: selectedLinkGlow 0.85s ease-in-out infinite alternate;
      pointer-events: none;
      z-index: -1;
    }
    /* Keep the glow ~1.65× the marker so the ratio matches 360 + 3D — the CML
       triangle is larger than the TML square. */
    .markup-link[data-tag-type="CML"].highlighted-link::after { width: 34px; height: 34px; }
    .markup-link[data-tag-type="TML"].highlighted-link::after { width: 30px; height: 30px; }
    @keyframes selectedLinkGlow {
      from { transform: translate(-50%, -50%) scale(0.7); opacity: 0.6; }
      to   { transform: translate(-50%, -50%) scale(1.6); opacity: 0.12; }
    }
  `;
  document.head.appendChild(style);
}

/** Link element selectors for all contexts: the PDF viewer (.markup-link), Edit markup
 * (.markup-link-popup, markupsPopup.vue) and V7 import boxes (.v7-annotation-box). */
const LINK_ELEMENT_SELECTORS = '.markup-link, .markup-link-popup, .v7-annotation-box';
const LINK_HIGHLIGHT_CLASSES = Object.freeze(['highlighted-link', 'link-flash', 'selected-markup-link', 'highlighted-markup-link']);

/** The link elements of `viewer`, or of the whole page when the viewer has none. */
function linkElementsOf(viewer) {
  const inViewer = viewer?.container?.querySelectorAll(LINK_ELEMENT_SELECTORS) || [];
  return inViewer.length ? inViewer : document.querySelectorAll(LINK_ELEMENT_SELECTORS);
}

function clearLinkHighlight(el) {
  el.classList.remove(...LINK_HIGHLIGHT_CLASSES);
  el.style.removeProperty('--flash-color');
  el.style.removeProperty('--flash-color-light');
  el.style.removeProperty('opacity'); // revert the Focus-Mode-override we set on highlight
}

/**
 * The persistent highlight — a pulsing condition-colored glow disc (see ensureLinkHighlightStyles),
 * consistent with the 3D/360 glow highlights.
 * Beat Focus-Mode isolation (`.markup-link:not([data-metadata=focusTag]) { opacity:.4 !important }`):
 * a highlighted off-focus CML/TML link must pop to full opacity. Inline !important wins over the
 * injected stylesheet rule; removed again on un-highlight so the link reverts to whatever Focus Mode dictates.
 */
function applyLinkHighlight(el, flashColor) {
  el.classList.add('highlighted-link');
  el.style.setProperty('--flash-color', flashColor);
  el.style.setProperty('opacity', '1', 'important');
}

/**
 * Highlight a link element in the viewer with flash animation.
 */
export function highlightLinkElement(link, viewer, overrideColor) {
  if (!link || !viewer?.container) {
    return;
  }
  ensureLinkHighlightStyles();

  const linkId = String(link.id || link.linkedAttachmentId);
  const tagId = link.tagId ? String(link.tagId) : null;
  // Cross-viewer sync passes the CML condition color so the doc highlight matches
  // the 3D/360 markers; other callers (tag-open highlight) keep the link-type color.
  const flashColor = overrideColor || LINK_TYPE_COLORS[link.type] || LINK_TYPE_COLORS.default;

  // Search in viewer container first, then globally if not found
  const linkElements = linkElementsOf(viewer);

  let targetElement = null;

  debugLog(`[highlightLinkElement] Searching for linkId=${linkId}, tagId=${tagId}, found ${linkElements.length} elements`);

  linkElements.forEach((el) => {
    const elId = String(el.getAttribute('data-id') || el.id || '');
    const elTagId = el.getAttribute('data-metadata') ? String(el.getAttribute('data-metadata')) : null;

    // Use string comparison to avoid type mismatches
    if (elId === linkId || (tagId && elTagId === tagId)) {
      targetElement = el;
      debugLog(`[highlightLinkElement] Found matching element:`, el);
    }
  });

  if (!targetElement) {
    debugLog('[highlightLinkElement] No matching element found');
    return;
  }

  // Clear any existing highlights first
  linkElements.forEach(clearLinkHighlight);
  applyLinkHighlight(targetElement, flashColor);

  debugLog('[highlightLinkElement] Highlight applied successfully');
}

/**
 * Highlight every link of these tags at once (a line can have many links on one drawing), after
 * clearing the others; each in its own link-type color. The AVA Assistant's ui.documents.open, via
 * the viewer adapter (src/platform/viewer/documents.js).
 * @param {string[]} tagIds
 * @param {object} viewer the document viewer
 * @returns {string[]} the tag ids, as given, that now have a highlighted link element
 */
export function highlightTagLinkElements(tagIds, viewer) {
  if (!viewer?.container || !Array.isArray(tagIds) || !tagIds.length) return [];
  ensureLinkHighlightStyles();
  const wanted = new Map(tagIds.map((id) => [String(id).toLowerCase(), id]));
  const linkElements = Array.from(viewer.container.querySelectorAll(LINK_ELEMENT_SELECTORS));
  const lit = new Set();
  linkElements.forEach(clearLinkHighlight);
  linkElements.forEach((el) => {
    const key = String(el.getAttribute('data-metadata') || '').toLowerCase();
    if (!key || !wanted.has(key)) return;
    applyLinkHighlight(el, LINK_TYPE_COLORS[el.getAttribute('data-tag-type')] || LINK_TYPE_COLORS.default);
    lit.add(wanted.get(key));
  });
  return tagIds.filter((id) => lit.has(id));
}

/** The tag ids of the link elements drawn in `viewer` now (each once), for the viewer adapter. */
export function renderedLinkTagIds(viewer) {
  if (!viewer?.container) return [];
  const ids = Array.from(viewer.container.querySelectorAll(LINK_ELEMENT_SELECTORS))
    .map((el) => el.getAttribute('data-metadata'))
    .filter(Boolean);
  return [...new Set(ids)];
}

/**
 * Cross-viewer sync: pan/zoom the doc (PDF/image) viewer so `link` is on-screen —
 * but ONLY if it is currently off-screen, so a user already looking at it isn't
 * jarred by a re-zoom. `link.position` is the link's world point (the same coords
 * create3DIconToViewer places the marker at). The fit span scales to the sheet's
 * bounding box so the zoom is sane for both PDF (model units) and image (8-unit
 * plane) viewers. See .claude/features/CROSS_VIEWER_MARKER_SYNC.md.
 */
export function ensureDocLinkVisible(link, viewer) {
  const pos = link && link.position;
  if (!pos || !viewer || !viewer.navigation || !viewer.container) return;

  // Already comfortably on-screen? Leave the camera alone.
  const linkId = String(link.id || link.linkedAttachmentId || '');
  const el = linkId ? viewer.container.querySelector(`.markup-link[data-id="${linkId}"]`) : null;
  if (el) {
    const cont = viewer.container.getBoundingClientRect();
    const r = el.getBoundingClientRect();
    const margin = 24;
    const onScreen = r.width > 0 && r.height > 0
      && r.left >= cont.left + margin && r.right <= cont.right - margin
      && r.top >= cont.top + margin && r.bottom <= cont.bottom - margin;
    if (onScreen) return;
  }

  let sheetSpan = store.state.markupImageWidth || 8;
  try {
    const mb = viewer.model && viewer.model.getBoundingBox && viewer.model.getBoundingBox();
    if (mb) sheetSpan = Math.max(mb.max.x - mb.min.x, mb.max.y - mb.min.y) || sheetSpan;
  } catch (err) {
    debugLog('[ensureDocLinkVisible] bounding box unavailable', err);
  }
  const span = sheetSpan / 8;
  const z = pos.z || 0;
  const box = new THREE.Box3(
    new THREE.Vector3(pos.x - span, pos.y - span, z - 0.01),
    new THREE.Vector3(pos.x + span, pos.y + span, z + 0.01),
  );
  viewer.navigation.fitBounds(true, box, false, true);
  debugLog('[ensureDocLinkVisible] moved doc camera to link', linkId);
}

export async function drawImageOnPlane(url, pdfviewer) {
  var base64 = await getBase64FromUrl(url);
  drawImage64OnPlane(base64, pdfviewer);
}

export function drawImage64OnPlane(base64, pdfviewer) {
  pdfviewer.setBackgroundColor(255, 255, 255, 255, 255, 255);
  if (!pdfviewer.overlays.hasScene('custom-scene')) pdfviewer.overlays.addScene('custom-scene');

  pdfviewer.overlays.clearScene();
  if (pdfviewer.imageMesh) {
    pdfviewer.overlays.removeMesh(pdfviewer.imageMesh, 'custom-scene');
    pdfviewer.imageMesh.geometry.dispose();
    pdfviewer.imageMesh.material.map.dispose();
    pdfviewer.imageMesh.material.dispose();
    pdfviewer.imageMesh = null;
  }

  const image = new Image();
  image.onload = () => {
    var texture = THREE.ImageUtils.loadTexture(image.src);
    texture.needsUpdate = true;
    texture.minFilter = THREE.NearestFilter;

    // if (image.width < image.height)
    //     texture.repeat.setX(image.height / image.width)
    // else
    //     texture.repeat.setY(image.width / image.height)

    let material = new THREE.MeshBasicMaterial({ map: texture });
    var width = 8;
    var height = (width * image.height) / image.width;
    const geometry = new THREE.PlaneBufferGeometry(width, height);

    var mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(4, height / 2, 0.001);

    pdfviewer.overlays.addMesh(mesh, 'custom-scene');
    pdfviewer.imageMesh = mesh;

    let min = new THREE.Vector3(0, 0, 0);
    let max = new THREE.Vector3(width, height, 0);
    var box = new THREE.Box3(min, max);
    pdfviewer.navigation.fitBounds(true, box, false, true);
    store.state.markupImageWidth = width;
    store.state.markupImageHeight = height;

    pdfviewer.impl.invalidate(true, true, true);
  };
  image.src = base64;
}
//https://stackoverflow.com/questions/22172604/convert-image-from-url-to-base64
export async function getBase64FromUrl(url) {
  // SAS URLs contain authentication in the query string, no headers needed
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
}
export function updateMarkupsOnViewer(
  viewer = store.state.pdfviewer,
  jsonData,
  layerName = 'Layer_1',
) {
  viewer.loadExtension('Autodesk.Viewing.MarkupsCore').then(function (extension) {
    //Enable stamp markup
    var promise = new Promise((resolve) => {
      // var rootPath = (appConfig.debugMode ? '../../' : appConfig.UI_URL);
      // var rootPath = '@/extensions/StampExtension.js'

      require(`@/extensions/StampExtension.js`);

      let ext = viewer.getExtension('StampExtension');
      if (ext) {
        resolve();
      } else {
        viewer.loadExtension('StampExtension').then(resolve);
      }
    });
    promise.then(() => {
      //Just to create a new markup layer with LayerName
      extension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
      extension.leaveEditMode(); //Leave edit mode to allow creation of new layer
      extension.loadMarkups('', layerName); //Enforce create new markups layer

      extension.enterEditMode(layerName);
      extension.clear();
      extension.leaveEditMode();

      var editor = extension;
      var avemc = Autodesk.Viewing.Extensions.Markups.Core;
      const stampExtensionJs = require('./../../extensions/StampExtension');
      for (var i = 0; i < jsonData.length; i++) {
        var currentMarkup = jsonData[i];
        var createMarkup = null;
        var id = currentMarkup.id;
        var tail = currentMarkup.tail;
        var head = currentMarkup.head;
        var style = currentMarkup.style;
        var size = currentMarkup.size;
        var text = currentMarkup.text;
        var position = currentMarkup.position;
        var rotation = currentMarkup.rotation;
        var closed = currentMarkup.closed;
        var locations = currentMarkup.locations;

        switch (jsonData[i].type) {
          case 'arrow':
            createMarkup = new avemc.CreateArrow(editor, id, tail, head, style);
            break;
          case 'label':
            createMarkup = new avemc.CreateText(editor, id, position, size, text, style);
            break;
          case 'ellipse':
            createMarkup = new avemc.CreateCircle(editor, id, position, size, rotation, style);
            break;
          case 'cloud':
            createMarkup = new avemc.CreateCloud(editor, id, position, size, rotation, style);
            break;
          case 'callout':
            createMarkup = new avemc.CreateCallout(editor, id, position, size, rotation, style);
            break;
          case 'rectangle':
            createMarkup = new avemc.CreateRectangle(editor, id, position, size, rotation, style);
            break;
          case 'freehand':
            createMarkup = new avemc.CreateFreehand(
              editor,
              id,
              position,
              size,
              rotation,
              locations,
              style,
            );
            break;
          case 'highlight':
            createMarkup = new avemc.CreateHighlight(
              editor,
              id,
              position,
              size,
              rotation,
              locations,
              style,
            );
            break;
          case 'polyline':
            createMarkup = new avemc.CreatePolyline(
              editor,
              id,
              position,
              size,
              rotation,
              locations,
              style,
              closed,
            );
            break;
          case 'polycloud':
            createMarkup = new avemc.CreatePolycloud(
              editor,
              id,
              position,
              size,
              rotation,
              locations,
              style,
              closed,
            );
            break;
          case 'stamp':
            var customSVG = avemc.Utils.stringToSvgNode(currentMarkup.svg);
            createMarkup = new stampExtensionJs.StampCreateAction(
              editor,
              id,
              position,
              size,
              rotation,
              style,
              customSVG,
            );
            break;
        }
        if (createMarkup) {
          createMarkup.addToHistory = false;
          extension.enterEditMode(layerName);
          createMarkup.execute();
        }
      }
      extension.leaveEditMode();
    });
  });

  viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
    // AVA-437 #7a — pause the CML/TML popup's rAF anchor-tracking during a doc/PDF
    // pan/zoom too. The doc-viewer popup (linkPreviewPopup → openPopupCard) anchors
    // to a `.markup-link` label that THIS handler repositions every camera frame;
    // without pausing, usePopupCard's per-frame getBoundingClientRect thrashes layout
    // → the same lag the 3D viewer had. This is the doc-viewer analog of forgeService
    // `_cmlCameraHandler` (which only fires on store.state.viewer). Guarded inside
    // `_flagForgeViewerInteracting` — no-ops unless a popup is open; same shared flag
    // + 300ms coast timer the rAF gate reads.
    store.state.forgeService?._flagForgeViewerInteracting?.();
    store.state.forgeService.updateLabelsPositionsByClassName('markup-link', viewer);
    store.state.forgeService.updateLabelsPositionsByClassName(
      'markups-link-preview-popup-container',
      viewer,
    );
  });
}
export async function pdfViewerOpenPageByNumber(pageNumber) {
  if (!pageNumber || isNaN(pageNumber) || pageNumber < 1) {
    return;
  }

  store.commit('setActiveAttachmentPage', pageNumber);
  var activeAttachment = store.state.MARKUPS.activeAttachment;
  // The document's own file; for an image it is drawn onto the empty page loaded below.
  var pdfUrl = await fetchDocumentAsObjectUrl(activeAttachment);
  var pdfViewer = store.state.pdfviewer;
  if (!pdfUrl || !pdfViewer) return;

  if (pdfViewer.model) {
    pdfViewer.unloadModel();
  }
  pdfViewer.loadedExtensions['Autodesk.PDF'].load().then(() => {
    var url = store.state.isMarkupImage ? getEmptyFileUrl() : pdfUrl;
    pdfViewer.loadModel(
      url,
      {
        page: pageNumber,
      },
      (doc) => {
        if (store.getters['getIsFlutterRunning']) onMarkupViewerLoaded();

        //draw image on plane if image
        if (store.state.isMarkupImage) drawImageOnPlane(pdfUrl, pdfViewer);

        let page = activeAttachment.pagesMarkups.find((o) => o.pageId == pageNumber);
        if (page?.rotation) {
          rotateViewerCamera(pdfViewer, page?.rotation);
        }
        //try clearing markups anyways
        var extension = pdfViewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];
        extension.enterEditMode();
        extension.clear();
        extension.unloadMarkupsAllLayers();
        extension.leaveEditMode();

        // remove previous links if any...
        $(pdfViewer.container).find('.markup-link').remove();

        if (page) {
          if (page.links) {
            page.links.forEach((link) => {
              var iconOptions = {
                position: link.position,
                width: link.width,
                height: link.height,
                rotation: link.rotation,
                differences: null,
                title: link.name,
                id: link.id ?? link.linkedAttachmentId,
                className: 'markup-link',
                forgeViewer: store.state.pdfviewer,
                metadata: link.tagId,
                linkType: link.type,
                cmlId: resolveLinkCmlId(link),
                onClick: (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  var element = e.srcElement;
                  link.element = element;
                  store.commit('setPreviewingLinkElement', element);
                  store.commit('setPdfViewerPreviewingLink', link);
                },
                addContent: true,
                removeTildeSign: true,
              };
              store.state.forgeService.create3DIconToViewer(iconOptions);
            });

            // Patch CML/TML links to their condition color (render-then-patch;
            // fails open to link-type color). Reuses the warm facility cache.
            applyCmlConditionColorsToDocLinks(pdfViewer.container);
          }

          if (page.markupText) {
            var markupJson = JSON.parse(page.markupText);
            if (markupJson) {
              updateMarkupsOnViewer(pdfViewer, markupJson, 'Layer_1');
            }
          }
        } else {
          // remove previous links if any...
          $(pdfViewer.container).find('label.markup-link').remove();
        }
      },
    );
  });
}

const onViewerLoaded_Flutter = window.onViewerLoaded_Flutter;
export function onMarkupViewerLoaded() {
  try {
    onViewerLoaded_Flutter?.postMessage('test');
  } catch (error) {
    debugError(error);
  }
}

const onSave_Flutter = window.onSave_Flutter;
export function onSaveFlutter() {
  try {
    onSave_Flutter?.postMessage('markups saved');
  } catch (error) {
    debugError(error);
  }
}

const onEditModeLeave_Flutter = window.onEditModeLeave_Flutter;
export function onEditModeLeaveFlutter() {
  try {
    onEditModeLeave_Flutter?.postMessage('onEditModeLeave');
  } catch (error) {
    debugError(error);
  }
}

const onHistoryChanged_Flutter = window.onHistoryChanged_Flutter;
export function onHistoryChangedFlutter(message) {
  try {
    onHistoryChanged_Flutter?.postMessage(message); //undo and redo status
  } catch (error) {
    debugError(error);
  }
}

const onMarkupLinkClicked_Flutter = window.onMarkupLinkClicked_Flutter;
export function onMarkupLinkClickedFlutter(link) {
  try {
    let metadata = JSON.parse(link.metadata);

    if (!metadata?.id) return;

    onMarkupLinkClicked_Flutter?.postMessage(metadata.id);
  } catch (error) {
    debugError(error);
  }
}

export function getViewPage360() {
  return store.state.mainApp?.$children
    ?.filter((o) => o.$vnode?.tag?.includes('PageView'))
    ?.find((o) => o.view_type == '360');
}

export function getViewPage3D() {
  return store.state.mainApp?.$children
    ?.filter((o) => o.$vnode?.tag?.includes('PageView'))
    ?.find((o) => o.view_type == '3d');
}

export function getViewPage2d() {
  return store.state.mainApp?.$children
    ?.filter((o) => o.$vnode?.tag?.includes('PageView'))
    ?.find((o) => o.view_type == '2d');
}

export function getViewPageDoc() {
  return store.state.mainApp?.$children
    ?.filter((o) => o.$vnode?.tag?.includes('PageView'))
    ?.find((o) => o.view_type == 'doc');
}

export function getViewPageOfficeDoc() {
  return store.state.mainApp?.$children
    ?.filter((o) => o.$vnode?.tag?.includes('PageView'))
    ?.find((o) => o.view_type == 'office-doc');
}

export function getViewPageVideo() {
  return store.state.mainApp?.$children
    ?.filter((o) => o.$vnode?.tag?.includes('PageView'))
    ?.find((o) => o.view_type == 'vid');
}

/**
 * Check if any viewer is currently open (3D, 2D plan, PDF/doc, or 360 panorama)
 * @returns {boolean} True if any viewer is open
 */
export function isAnyViewerOpen() {
  const has3DViewer = !!store.state.viewer;
  const has2DViewer = !!store.state.planViewer;
  const hasPdfViewer = !!store.state.pdfviewer;
  const has360Viewer = !!store.state.forgeService?.panoramaViewer;
  return has3DViewer || has2DViewer || hasPdfViewer || has360Viewer;
}

export function getMessagePopup() {
  if (store.state.mainApp && !router.currentRoute.path.includes('/admin'))
    return store.state.mainApp.$children.find((o) => o.$vnode.tag.includes('MessagePopup'));
  else
    return store.state.adminAppContainer.$children.find((o) =>
      o.$vnode.tag.includes('MessagePopup'),
    );
}

export function getMarkupsComponent() {
  if (store.state.mainApp)
    return store.state.mainApp.$children.find((o) => o.$vnode.tag.includes('markups-popup'));
  else
    return store.state.adminApp.$children[0].$children.find((o) =>
      o.$vnode.tag.includes('markups-popup'),
    );
}
export function showCopiedTextPopup(text, warning) {
  let component = store.state.mainApp.$children.find((o) => o.$vnode.tag.includes('copied-text'));
  component.show(text, warning);
}

export function toggleExpandComponent(component) {
  if (!component) return;
  var result = !component.isExpanded;
  store.state.adminAppContainer?.$children?.forEach((o) => (o.isExpanded = false));
  component.isExpanded = result;
}

export function getEditLevelComponent() {
  return store.state.adminAppContainer.$children.find((o) => o.$vnode.tag.includes('EditLevel'));
}

export class getPointOnViewerHandler {
  constructor(viewer) {
    this.viewer = viewer;
    this.panning = false;

    return new Promise((resolve, reject) => {
      if (!viewer) {
        reject('Viewer is not initialized');
        return;
      }

      let mousedownHandler = (event) => {

        if (this.panning) return;

        var hitTest = viewer.clientToWorld(event.offsetX, event.offsetY, false);

        if (!hitTest?.point) return;

        viewer.canvas.removeEventListener('mouseup', mousedownHandler);

        debugLog(`%c Point:`, `color: green; font-size: 16px;`, hitTest?.point);

        resolve(hitTest?.point);
      };

      viewer.canvas.addEventListener('mousedown', () => (this.panning = false));

      viewer.canvas.addEventListener('mousemove', () => (this.panning = true));

      viewer.canvas.addEventListener('mouseup', mousedownHandler);
    });
  }
}
